import Rack from '@/models/Rack/Rack';

export default class RackFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.code = '';
		this.name = '';
		this.areaId  = '';
		this.areaCode = '';
		this.customerId  = '';
		this.customerCode = '';
		this.lineId  = '';
		this.lineCode = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			code : '0',
			name : '0',
			areaId : '0',
			areaCode : '0',
			customerId : '0',
			customerCode : '0',
			lineId : '0',
			lineCode : '0',
			partId : '0',
			partPartNumber : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}